import React from "react";
import {observer} from "mobx-react";
import {OrbitComponent} from "../base-components/orbit-component/orbit-component";
import { LottieAnimatedTopImageComponent } from "./lottie-animated-top-image.component";
import {PixiAnimatedTopImageComponent} from "./pixi-animated-top-image.component";
import {AnimatedTopImageConfiguration} from "../../services/configurations/config-data-sections/arenas.configuration";


export interface AnimatedTopImageComponentProps {
    imageAnimationConfig: AnimatedTopImageConfiguration;
}
@observer
export class AnimatedTopImageComponent extends OrbitComponent<AnimatedTopImageComponentProps> {
    render() {
        if (this.props.imageAnimationConfig.engine === "pixi") {
            return <PixiAnimatedTopImageComponent image={this.props.imageAnimationConfig.url} />
        }
        return <LottieAnimatedTopImageComponent image={this.props.imageAnimationConfig.url} />
    }
}